import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var SecurityDomain = /** @class */ (function (_super) {
    __extends(SecurityDomain, _super);
    function SecurityDomain() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SecurityDomain, "currentDomain", {
        //todo!
        get: function () {
            return null;
        },
        enumerable: true,
        configurable: true
    });
    return SecurityDomain;
}(ASObject));
export { SecurityDomain };
